import { useMutation, useQuery, useQueryClient } from 'react-query';
import { getCards, deleteCard, DeleteCardProps } from './rest';
import { useBraintreeClient } from './context';
import { CardPayment } from './types';

export function useCards() {
    const client = useBraintreeClient();
    return useQuery(['braintree-cards'], () => getCards(client), {
        useErrorBoundary: true,
    });
}

export function useCardRemove() {
    const queryClient = useQueryClient();
    const client = useBraintreeClient();
    return useMutation((props: DeleteCardProps) => deleteCard(client, props), {
        async onMutate(props: DeleteCardProps) {
            const data = queryClient.getQueryData<CardPayment[]>(['braintree-cards']);

            const filteredData = data?.filter((card) => card.nonce !== props.singleUseTokenId);

            if (data) {
                queryClient.setQueryData(['braintree-cards'], filteredData);
            }

            return data;
        },
        onError(_err, _, context) {
            queryClient.setQueryData(['braintree-cards'], context);
        },
        async onSuccess() {
            await queryClient.invalidateQueries(['braintree-cards']);
        },
    });
}
